/**
 * Who holds the superhost badge, as `{ byId: { [userId]: { active, valid_until } } }`.
 *
 * The status no longer lives in Sharetribe's `publicData.superhost`: it is in
 * Postgres, and the server puts the current list into the preloaded state of
 * every SSR render (`server/dataLoader.js`). That is the only way it arrives —
 * there are no actions. `configureStore` hands it to `setSuperhostRegistry`
 * (`src/util/superhost.js`), which is what every badge check reads, so a logout
 * resetting this slice does not hide anybody's badge.
 *
 * See docs/superhost.md.
 */

const initialState = { byId: {} };

export default function superhostsReducer(state = initialState) {
  return state;
}
